<template>
  <div class="flex flex-col w-full h-full bg-white gap-2">
    <!-- content with left, right arrow -->
    <div class="flex flex-grow items-stretch">
      <div class="w-6 h-full flex">
        <button @click="prevImage" v-if="hasPrevImage" class="w-6 hover:bg-trader-blue hover:text-white">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <div class="flex flex-grow justify-center items-center bg-no-repeat bg-contain bg-center"
           :style="{ backgroundImage: `url(${pictures[pictureIndex]?.previewLarge})` }">
      </div>
      <div class="w-6 h-full flex">
        <button @click="nextImage" v-if="hasNextImage" class="w-6 hover:bg-trader-blue hover:text-white">
          <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- miniaturbilder -->
    <div class="flex justify-center gap-2">
      <div v-for="(image, idx) in pictures" :key="image?.path"
           class="flex items-center justify-center border-2 h-[70px] w-[90px] min-h-[40px] max-h-[75px] min-w-[20px] max-w-[90px]"
           :class="{'border-trader-blue': idx === pictureIndex}"
           @click="setIndex(idx)">
        <img v-if="image?.previewSmall" :src="image?.previewSmall" class="min-w-[10px] max-w-[80px] min-h-[10px] max-h-[65px]">
      </div>
    </div>

    <!-- footer -->
    <div class="flex p-2 items-end">
      <div v-if="pictures.length > 0">
        <button v-if="showButton" @click="onAssignPicture" class="bg-active text-white rounded p-2">
          Bild zuweisen
        </button>
      </div>
      <div class="flex-grow flex flex-col p-4">
        <h1 class="font-bold text-lg">Produktbild Informationen</h1>
        <p><span class="font-bold">Aktualisiert am:</span> {{ pictures[pictureIndex]?.dateTimeUpdated }}</p>
        <p><span class="font-bold">Hinzugefügt am:</span> {{ pictures[pictureIndex]?.dateTimeCreated}}</p>
        <p><span class="font-bold">Bildname:</span> {{ pictures[pictureIndex]?.name }}</p>
      </div>
      <div>
        <button @click="closeModal" class="bg-active text-white rounded p-2">Schließen</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { eventBus } from '@/application/EventBus';
import SignalBus from '@/application/SignalBus';

const props = defineProps({
  pictures: {
    type: Array,
    default: () => [],
  },
  selectedIndex: {
    type: Number,
    default: 0,
  },
  showButton: {
    type: Boolean,
    default: false,
  }
});

const { closeModal } = eventBus;
const pictureIndex = ref(props.selectedIndex);

const hasNextImage = computed(() => pictureIndex.value < props.pictures.length - 1);
function nextImage() {
  if (hasNextImage.value) {
    pictureIndex.value += 1;
  }
}

const hasPrevImage = computed(() => pictureIndex.value > 0);
function prevImage() {
  if (hasPrevImage.value) {
    pictureIndex.value -= 1;
  }
}

const setIndex = (idx) => {
  pictureIndex.value = idx;
};

function onAssignPicture() {
  SignalBus.emit('assign-picture-to-product', props.pictures[pictureIndex.value]);
  closeModal();
}
</script>

